const imageData = [
    {
        id: 63,
        title: "Momo",
        author: "Michael Ende",
        description: "Questo è probabilmente il mio libro preferito, adoro la fantasia con cui si descrive la protagonista, Momo, una bambina che vive in un anfiteatro e viene da non si sa dove e non si sa quando, con dei capelli neri ricci e scompigliati, che indossa sempre un giaccone che le arriva fino alle gambe, è una bambina speciale che sa ascoltare chiunque le chieda aiuto e deve affrontare gli uomini grigi apparsi in città, intenti a rubare il tempo alle persone...",
        imageUrl: "/booksimages/Momo.jpg"
    },
    {
        id: 49,
        title: "La notte dei desideri",
        author: "Michael Ende",
        description: "E' lo stesso scrittore di Momo, anche questo tra i miei libri preferiti. E' la vigilia di capodanno e uno stregone guarda ansioso il fuoco, aspetta una visita non gradita. Fa parte dell'ordine degli stregoni, che porta il caos sulla terra, e quest'anno non ha compiuto affatto il suo dovere, deve assolutamente completare il numero di malefatte previsto dal contratto con le forze infernali, altrimenti andra all'inferno. Lui e un'altra strega nella sua stessa condizione, sua zia, decidono di preparare un potente elisir magico, chiamato satanarchibugiardinfernalcolico Grog di Magog, che permetterà loro, in poche ore, di causare enormi disastri in tutto il mondo... Tuttavia, due agenti segreti del Bene vengono a sapere del piano: un gatto parlante pantofolone e un corvo. Entrambi lavorano per la Lega degli Animali, un’organizzazione che protegge la natura. Hanno solo sei ore, fino a mezzanotte, per impedire la catastrofe.",
        imageUrl: "/booksimages/La_notte_dei_desideri.jpeg"
    },
    {
        id: 80,
        title: "Il bambino la talpa la volpe e il cavallo",
        author: "Charlie Mackesy",
        description: "Nella sua semplicità, questo libro è assolutamente straziante per me da leggere. E' così bello perché è un libro sincero, scritto in modo genuino, per la sua delicatezza nel porgere frasi semplici con un significato non scontato. I personaggi del libro vivono una piccola avventura, resa tale dal semplice fatto di stare insieme, ciascuno allo stesso tempo ha e non ha un ruolo nella storia, si apprezzano come sono, quattro amici per caso.",
        imageUrl: "/booksimages/Il_bambino_la_talpa_la_volpe_il_cavallo.jpg"
    },
    {
        id: 9,
        title: "Coraline",
        author: "Neil Gaiman",
        description: "Libro magistrale, reso tale anche dal film che gli rende decisamente giustizia. E' tanto originale quanto lugubre e misterioso, combo perfetta affinché un libro piaccia al sottoscritto, in cima alla lista.",
        imageUrl: "/booksimages/Coraline.jpg"
    },
    {
        id: 14,
        title: "Furbo, il Signor Volpe",
        author: "Roald Dahl",
        description: "Libro molto dolce e leggero, su una famiglia di volpi che cerca di sopravvivere degli allevatori, ne hanno tratto un film, che espande di molto la trama ma è mani basse tra le mie storie preferite.",
        imageUrl: "/booksimages/Furbo_il_Signor_Volpe.jpeg"
    },
    {
        id: 41,
        title: "L'uomo di ferro",
        author: "Ted Hughes",
        description: "E' il libro da cui hanno tratto il film Il gigante di ferro, ma non illudetevi, la trama è decisamente diversa, solo un paio dei personaggi del film sono presenti, e il protagonista metallico ad un certo punto combatte con un drago... ciò nonostante una lettura piacevole quanto surreale.",
        imageUrl: "/booksimages/L'uomo_di_ferro.jpg"
    },
    {
        id: 15,
        title: "Gli sporcelli",
        author: "Roald Dahl",
        description: "Credo che tutti da bambini abbiamo letto almeno una volta questo capolavoro, è dissacrante quanto divertente, per niente politically correct.",
        imageUrl: "/booksimages/Gli_sporcelli.jpg"
    },
    {
        id: 8,
        title: "Cent'anni di solitudine",
        author: "Gabriel García Márquez",
        description: "Questo libro davvero è geniale, mi sono reso conto solo a metà che non ha troppo senso cercare di ricordarsi a memoria tutti i nomi, perché alla fin fine tutti i personaggi si ripetono a modo loro nelle generazioni ed è proprio questo il centro del libro, il destino si ripete nella sua inevitabilità.",
        imageUrl: "/booksimages/Cent'anni_di_solitudine.jpg"
    },
    {
        id: 74,
        title: "Uomini che odiano le donne",
        author: "Stieg Larsson",
        description: "Questo libro è bello da morire, i personaggi sono realistici ma complessi, vari, e soprattutto ben sviluppati, la trama per trovare l'omicida si articola su diversi livelli e nei libri successivi i colpi di scena sono devastanti. Se leggi le prime 50 pagine divori i 3 libri della serie in un weekend per sapere come va a finire.",
        imageUrl: "/booksimages/Uomini_che_odiano_le_donne.jpg"
    },
    {
        id: 50,
        title: "La ragazza che giocava con il fuoco",
        author: "Stieg Larsson",
        description: null,
        imageUrl: "/booksimages/La_ragazza_che_giocava_con_il_fuoco.jpg"
    },
    {
        id: 51,
        title: "La regina dei castelli di carta",
        author: "Stieg Larsson",
        description: null,
        imageUrl: "/booksimages/La_regina_dei_castelli_di_carta.jpg"
    },
    {
        id: 52,
        title: "La terra desolata",
        author: "T. S. Eliot",
        description: null,
        imageUrl: "/booksimages/La_terra_desolata.jpg"
    },
    {
        id: 53,
        title: "La torre nera",
        author: "Stephen King",
        description: "E' il primo capitolo di una lunga serie, a livello di volume sarà lungo almeno 3 o 4 volte Harry Potter per darvi un idea ma caspita, ne vale la pena. Il protagonista, un pistolero in un mondo futuro ormai in rovina, insegue l'Uomo in nero nel deserto per scoprire come raggiungere La torre nera, un oggetto mistico fuori dal tempo e dallo spazio che tiene in piedi tutti gli universi nell'infinita relatà in cui si sviluppa la trama.",
        imageUrl: "/booksimages/La_torre_nera.jpg"
    },
    {
        id: 3,
        title: "Abbandonare un gatto",
        author: "Haruki Murakami",
        description: null,
        imageUrl: "/booksimages/Abbondonare_un_gatto.jpg"
    },
    {
        id: 4,
        title: "Aforismi di Antoine de Saint Exupery",
        author: "Antoine de Saint-Exupéry",
        description: null,
        imageUrl: "/booksimages/Aforismi_di_Antoine_de_Saint_Exupery.jpeg"
    },
    {
        id: 5,
        title: "Angeli e demoni",
        author: "Dan Brown",
        description: null,
        imageUrl: "/booksimages/Angeli_e_demoni.jpg"
    },
    {
        id: 10,
        title: "Da zero a uno",
        author: "Peter Thiel",
        description: null,
        imageUrl: "/booksimages/Da_zero_a_uno.jpg"
    },
    {
        id: 11,
        title: "Dalla terra alla luna",
        author: "Jules Verne",
        description: null,
        imageUrl: "/booksimages/Dalla_terra_alla_luna.jpg"
    },
    {
        id: 12,
        title: "Dieci piccoli indiani",
        author: "Agatha Christie",
        description: "Ho sempre evitato Agatha Christie, non so bene il motivo, questo libro però mi ha fatto cambiare idea, come stile di scrittura è diretta e non si perde troppo in fronzoli inutili o ragionamenti contorti o filosofie estreme, la trama si sviluppa bene senza annoiare.",
        imageUrl: "/booksimages/Diceci_piccoli_indiani.jpg"
    },
    {
        id: 13,
        title: "Fondazione Terra",
        author: "Isaac Asimov",
        description: null,
        imageUrl: "/booksimages/Fondazione_terra.jpg"
    },
    {
        id: 16,
        title: "Guida galattica per autostoppisti",
        author: "Douglas Adams",
        description: null,
        imageUrl: "/booksimages/Guida_galattica_per_autostoppisti.jpg"
    },
    {
        id: 17,
        title: "Il blu è un colore caldo",
        author: "Julie Maroh",
        description: null,
        imageUrl: "/booksimages/Il_blu_è_un_colore_caldo.jpg"
    },
    {
        id: 18,
        title: "Il buio oltre la siepe",
        author: "Harper Lee",
        description: null,
        imageUrl: "/booksimages/Il_buio_oltre_la_siepe.jpg"
    },
    {
        id: 81,
        title: "Ready player one",
        author: "Ernest Kline",
        description: null,
        imageUrl: "/booksimages/Ready_player_one.jpg"
    },
    {
        id: 19,
        title: "Il castello errante di Howl",
        author: "Diana Wynne Jones",
        description: null,
        imageUrl: "/booksimages/Il_castello_errante_di_Howl.jpg"
    },
    {
        id: 20,
        title: "Il castello in aria",
        author: "Diana Wynne Jones",
        description: null,
        imageUrl: "/booksimages/Il_castello_in_aria.jpg"
    },
    {
        id: 42,
        title: "La casa per ognidove",
        author: "Emily Rodda",
        description: null,
        imageUrl: "/booksimages/La_casa_per_ognidove.jpg"
    },
    {
        id: 40,
        title: "L'ultimo elfo",
        author: "Silvana De Mari",
        description: null,
        imageUrl: "/booksimages/L'ultimo_elfo.jpg"
    },
    {
        id: 21,
        title: "Il ciclo della fondazione",
        author: "Isaac Asimov",
        description: "E' una serie di libri epocale, davvero un capolavoro letterario senza precedenti, non è un libro di fantascienza, è letteralmente un libro di storia di diversi migliai di anni solo ambientato nel futuro. Le trame e gli sviluppi dei personaggi, così come la geopolitica che si sviluppa tra civiltà che interagiscono a migliai di anni luci di ditanza è devastante, e mette in luce la varietà dell'essere umano. Un gravissimo e irrimediabile problema attanaglia tuttavia questa serie di libri: Asimov li ha interrotti brutalmente, smise di scriverli dall'oggi al domani, riprese dopo vent'anni per dare alla serie un finale... ma francamente sarebbe stato meglio non lo avesse fatto, non ha minimamente retto il confronto. Bellissimi i personaggi femminili, veramente tosti e intraprendenti ma credibili, non abbozzati, soprattutto la bambina che cerca la fondazione, ma ragazzi la scena del Mulo... in questa storia, questa trama, è veramente un colpo di scena devastante.",
        imageUrl: "/booksimages/Il_ciclo_della_fondazione.JPG"
    },
    {
        id: 22,
        title: "Il cimitero senza lapidi",
        author: "Neil Gaiman",
        description: null,
        imageUrl: "/booksimages/Il_cimitero_senza_lapidi.jpg"
    },
    {
        id: 23,
        title: "Il coccodrillo enorme",
        author: "Roald Dahl",
        description: null,
        imageUrl: "/booksimages/Il_coccodrillo_enorme.jpg"
    },
    {
        id: 24,
        title: "Il codice da Vinci",
        author: "Dan Brown",
        description: null,
        imageUrl: "/booksimages/Il_codice_da_vinci.jpg"
    },
    {
        id: 25,
        title: "Il corvo",
        author: "Edgar Allan Poe",
        description: "Poesia bellissima, la imparai a memoria talmente ne ero ossessionato, il tono, la metafora del corvo, l'evolversi del tormento del protagonista...",
        imageUrl: "/booksimages/Il_corvo.jpeg"
    },
    {
        id: 26,
        title: "Il cuore rivelatore",
        author: "Edgar Allan Poe",
        description: null,
        imageUrl: "/booksimages/Il_cuore_rivelatore.jpg"
    },
    {
        id: 27,
        title: "Il curioso caso di Benjamin Button",
        author: "Francis Scott Fitzgerald",
        description: "Questo libro è folle. Non ho visto il film, non so se/quanto riprenda dal libro ma credo molto poco, comunque: una storia così semplice, e descritta in modod così genuino, naturale, che è provi quasi tenerezza per questo personaggio che è quasi sempre nel posto sbagliato nel tempo sbagliato. Ma a parte la storia folle di una persona che nasce vecchia e ringiovanisce, quello che è veramente assurdo di questo libro e che lo rende così speciale per me, è che ti propone una storia fuori dal mondo in un contesto così improponibile senza dare alcuna morale, non c'è uno spunto di riflessione, non viene accennata alcune metafora o allegoria, non c'è nemmeno una riga in cui lo scrittore si lascia andare ad un momento filosofico di introspezione del personaggio per far capire il messaggio della storia. Questo è. Fine. Concluso il libro mi ricordo di aver alzato lo sguardo e scrutato l'orizzonte per un po' pensando a cosa significasse tutta la storia. Ci sono un miliardo di interpretazioni, ma qual'è quella che ha spinto l'autore a scrivere il libro che stringevo tra le mani... non mi venne in mente niente, mi sentii vuoto, non avevo il minimo indizio per giungere ad una risposta. Da queste cose si distinguono i libri buoni dai capolavori.",
        imageUrl: "/booksimages/Il_curioso_caso_di_Benjamin_Button.jpg"
    },
    {
        id: 28,
        title: "Il dottor Semmelweis",
        author: "Louis-Ferdinand Céline",
        description: null,
        imageUrl: "/booksimages/Il_dottor_semmelweis.jpg"
    },
    {
        id: 29,
        title: "Il figlio del cimitero",
        author: "Neil Gaiman",
        description: null,
        imageUrl: "/booksimages/Il_figlio_del_cimitero.jpg"
    },
    {
        id: 30,
        title: "Il giro del mondo in 80 giorni",
        author: "Jules Verne",
        description: null,
        imageUrl: "/booksimages/Il_giro_del_mondo_in_80_giorni.jpg"
    },
    {
        id: 31,
        title: "Il libro delle storie di fantasmi",
        author: "Roald Dahl",
        description: null,
        imageUrl: "/booksimages/Il_libro_delle_storie_di_fantasmi.jpg"
    },
    {
        id: 32,
        title: "Il piccolo principe",
        author: "Antoine de Saint-Exupéry",
        description: null,
        imageUrl: "/booksimages/Il_piccolo_principe.jpg"
    },
    {
        id: 33,
        title: "Il pozzo e il pendolo",
        author: "Edgar Allan Poe",
        description: null,
        imageUrl: "/booksimages/Il_pozzo_e_il_pendolo.jpg"
    },
    {
        id: 34,
        title: "Il regno di Ga'Hoole",
        author: "Kathryn Lasky",
        description: "Ho letto questo libro da piccolo e l'ho amato, adoro i gufi e purtroppo sono un po' lasciati da parte nelle fiabe, ne hanno fatto un film anni dopo, non è malvagio ma non fu al livello del libro e fu un po' un flop purtroppo. Il libro uscì anche di produzione ed è introvabile, ho impiegato giorni a rimediare una copia.",
        imageUrl: "/booksimages/Il_regno_di_Gahoole.jpg"
    },
    {
        id: 35,
        title: "Il sole nudo",
        author: "Isaac Asimov",
        description: null,
        imageUrl: "/booksimages/Il_sole_nudo.jpg"
    },
    {
        id: 36,
        title: "Intelligenza emotiva",
        author: "Daniel Goleman",
        description: null,
        imageUrl: "/booksimages/Intelligenza_emotiva.jpg"
    },
    {
        id: 37,
        title: "Io uccido",
        author: "Giorgio Faletti",
        description: "Le premesse erano buone, il libro inizia con un'ottima prosa e i personaggi sono veramente vari e interessanti, c'è del lavoro e un ottimo spunto di fantasia, purtroppo più si va avanti nella storia più il libro in se peggiora, verso la fine è un po' troppo scontato e piatto, tutto l'inseguimento finale non è appassionante, è un po' troppo descrittivo e rallenta molto l'enfasi del finale.",
        imageUrl: "/booksimages/Io_uccido.jpg"
    },
    {
        id: 38,
        title: "L'occhio del lupo",
        author: "Daniel Pennac",
        description: null,
        imageUrl: "/booksimages/L'occhio_del_lupo.jpg"
    },
    {
        id: 39,
        title: "L'ombra dell'astronave",
        author: "Ursula K. Le Guin",
        description: null,
        imageUrl: "/booksimages/L'ombra_dell'astronave.jpg"
    },
    {
        id: 43,
        title: "La coscienza di Zeno",
        author: "Italo Svevo",
        description: null,
        imageUrl: "/booksimages/La_coscienza_di_Zeno.jpg"
    },
    {
        id: 44,
        title: "La fabbrica di cioccolato",
        author: "Roald Dahl",
        description: null,
        imageUrl: "/booksimages/La_fabbrica_di_cioccolato.jpg"
    },
    {
        id: 45,
        title: "La fisica dei supereroi",
        author: "James Kakalios",
        description: null,
        imageUrl: "/booksimages/La_fisica_dei_supereroi.JPG"
    },
    {
        id: 46,
        title: "La lega degli straordinari gentlemen",
        author: "Alan Moore",
        description: null,
        imageUrl: "/booksimages/La_lega_degli_straordinari_gentleman.jpg"
    },
    {
        id: 47,
        title: "La lettera rubata",
        author: "Edgar Allan Poe",
        description: null,
        imageUrl: "/booksimages/La_lettera_rubata_fronte.jpg"
    },
    {
        id: 48,
        title: "La maschera della morte rossa",
        author: "Edgar Allan Poe",
        description: "Ho ascoltato un'interpretazione tratrale di questa storia da solo in casa in piena notte, mi sono cagato sotto come poche volte nella vita. E' descritto talmente bene e in modo così realistico e scorrevole che ti sembra di prendere parte alla vicenda, e con il finale l'ansia ti penetra nel corpo direttamente.",
        imageUrl: "/booksimages/La_maschera_della_morte_rossa.jpeg"
    },
    {
        id: 6,
        title: "Ballando nudi nel campo della mente",
        author: "Kary Mullis",
        description: null,
        imageUrl: "/booksimages/Ballando_nudi_nel_campo_della_mente.jpg"
    },
    {
        id: 7,
        title: "Cambiare l'acqua ai fiori",
        author: "Valérie Perrin",
        description: "Quanto è scritto male sto libro mamma mia... davvero che schifo. Non mi esprimo sulla trama ma davvero, per la scrittura, non ci siamo. Nel parlavo con un mio amico e per dimostrare la mia tesi aprii una pagina a caso e iniziai a leggere, prima di trovare un aggettivo sono passate tre pagine, ho detto tutto. Inoltre trasuda egocentrismo, chi l'ha scritto sembra proprio degnarci delle sue sagge parole. Bah...",
        imageUrl: "/booksimages/Cambiare_l'acqua_ai_fiori.jpg"
    },
    {
        id: 54,
        title: "La vegetariana",
        author: "Han Kang",
        description: "Molto bello, ma pesante per me da leggere, alcune scene anche se in termini diversi le ho vissute sulla pelle quindi non è stata affatto una lettura piacevole. La descrizione dei sogni in cui macellano gli animali in particolare è turbante, perché quando divenni vegetariano passai mesi a fare gli stessi sogni se non peggiori.",
        imageUrl: "/booksimages/La_vegetariana.jpg"
    },
    {
        id: 55,
        title: "Le avventure di Jim Bottone",
        author: "Michael Ende",
        description: null,
        imageUrl: "/booksimages/Le_avventure_di_jim_bottone.jpg"
    },
    {
        id: 56,
        title: "Le notti bianche",
        author: "Fëdor Dostoevskij",
        description: null,
        imageUrl: "/booksimages/Le_notti_bianche.jpg"
    },
    {
        id: 57,
        title: "Le notti di Salem",
        author: "Stephen King",
        description: null,
        imageUrl: "/booksimages/Le_notti_di_salem.jpg"
    },
    {
        id: 58,
        title: "Lo hobbit",
        author: "J. R. R. Tolkien",
        description: null,
        imageUrl: "/booksimages/Lo_hobbit.jpeg"
    },
    {
        id: 59,
        title: "Ma gli androidi sognano pecore elettriche?",
        author: "Philip K. Dick",
        description: null,
        imageUrl: "/booksimages/Ma_gli_androidi_sognano_pecore_elettriche.jpg"
    },
    {
        id: 60,
        title: "Marcovaldo",
        author: "Italo Calvino",
        description: "Trobbo bello sto libro",
        imageUrl: "/booksimages/Marcovaldo.jpg"
    },
    {
        id: 61,
        title: "Matilde",
        author: "Roald Dahl",
        description: null,
        imageUrl: "/booksimages/Matilde.PNG"
    },
    {
        id: 62,
        title: "Maus",
        author: "Art Spiegelman",
        description: "Questo è uno di quei libri/fumetti che va letto almeno una volta nella vita, parlare di una storia sull'olocausto e farti restare attaccato al libro dalla prima all'ultima pagina vuol dire essere veramente bravi a raccontare le storie.",
        imageUrl: "/booksimages/Maus.jpg"
    },
    {
        id: 64,
        title: "Pensieri lenti e veloci",
        author: "Daniel Kahneman",
        description: null,
        imageUrl: "/booksimages/Pensieri_lenti_veloci_libro.jpg"
    },
    {
        id: 65,
        title: "Storia di un gatto e del topo che diventò suo amico",
        author: "Luis Sepúlveda",
        description: null,
        imageUrl: "/booksimages/Storia_di_un_gatto_e_del_topo_che_diventò_suo_amico.jpg"
    },
    {
        id: 66,
        title: "Storia di una balena bianca raccontata da lei stessa",
        author: "Luis Sepúlveda",
        description: null,
        imageUrl: "/booksimages/Storia_di_una_balena_bianca_raccontata_da_lei_stessa.jpg"
    },
    {
        id: 67,
        title: "Storie di giovani maghi",
        author: "Isaac Asimov",
        description: null,
        imageUrl: "/booksimages/Storie_di_giovani_maghi.jpg"
    },
    {
        id: 68,
        title: "Storie di giovani mostri",
        author: "Isaac Asimov",
        description: "Il termine mostri è fuorvianti. Chi sono i veri mostri in questi racconti? Vi suggerisco di spendere 10 minuti del vostro tempo a leggere la storia del ragazzo nato con le ali, cazzo quanto mi fa piangere...",
        imageUrl: "/booksimages/Storie_di_giovani_mostri.jpeg"
    },
    {
        id: 69,
        title: "Terra degli uomini",
        author: "Antoine de Saint-Exupéry",
        description: null,
        imageUrl: "/booksimages/Terra_degli_uomini.jpg"
    },
    {
        id: 70,
        title: "Belli e dannati",
        author: "F. Scott Fitzgerald",
        description: null,
        imageUrl: "/booksimages/The_Beautiful_and_Damned_first_edition_cover.png"
    },
    {
        id: 71,
        title: "Tutte le cosmicomiche",
        author: "Italo Calvino",
        description: null,
        imageUrl: "/booksimages/Tutte_le_cosmicomiche.jpg"
    },
    {
        id: 72,
        title: "Tutti i racconti del mistero, dell'incubo e del terrore",
        author: "Edgar Allan Poe",
        description: "La storia del gatto nero... va letta. E' disturbante, si, soprattutto se te la fanno leggere alle medie, si, ma è proprio questa la bravura di Allan Poe, ti fa ritrovare dove vuole lui, la fantasia (per quanto spesso macabra) non gli manca affatto.",
        imageUrl: "/booksimages/Tutti_i_racconti_del_mistero_dell'incubo_e_del_terrore.jpg"
    },
    {
        id: 73,
        title: "Uno, nessuno e centomila",
        author: "Luigi Pirandello",
        description: null,
        imageUrl: "/booksimages/Uno_nessuno_centomila.jpg"
    },
    {
        id: 75,
        title: "V per Vendetta",
        author: "Alan Moore",
        description: null,
        imageUrl: "/booksimages/V_per_vendetta.jpg"
    },
    {
        id: 76,
        title: "Ventimila leghe sotto i mari",
        author: "Jules Verne",
        description: null,
        imageUrl: "/booksimages/Ventimila_leghe_sotto_i_mari.jpg"
    },
    {
        id: 77,
        title: "Volo di notte e L'aviatore",
        author: "Antoine de Saint-Exupéry",
        description: null,
        imageUrl: "/booksimages/Volo_di_notte_e_l'aviatore.jpg"
    },
    {
        id: 78,
        title: "Narnia",
        author: "C.S.Lewis",
        description: null,
        imageUrl: "/booksimages/Narnia.jpg"
    },
    {
        id: 79,
        title: "La notte del drive-in",
        author: "Joe R. Lansdale",
        description: null,
        imageUrl: "/booksimages/La_notte_del_drivein.jpg"
    },
    {
        id: 1,
        title: "1984",
        author: "George Orwell",
        description: "Non mi ha fatto super mega impazzire e saltare dalla sedia devo essere sincero, apprezzabile se contestualizzato, per essere un libro di ottanta anni assurdo, ma ben più della metà del libro è una semplice descrizione statica di un mondo triste, noioso, grigio... capitemi è un po' pesante e non ti fa impazzire se lo si legge in piedi in metro a Milano alle 6:30 del mattino con due ore e passa di viaggio sui mezzi pubblici per andare a lavorare tutto il giorno in un ufficio...",
        imageUrl: "/booksimages/1984.jpg"
    },
    {
        id: 2,
        title: "300",
        author: "Frank Miller",
        description: null,
        imageUrl: "/booksimages/300.jpg"
    },
    {
        id: 82,
        title: "Armada",
        author: "Charlie Mackesy",
        description: null,
        imageUrl: "/booksimages/Armada.jpg"
    },
];
export default imageData;
